import {FC} from 'react'
import {Outlet, useLocation} from "react-router-dom"
import Head from './components/Head'
import Footer from './components/Footer'
import DealerFooter from './components/DealerFooter'
import style from './style.module.less'

const BaseLayout: FC = () => {
  const location = useLocation()

  return (
    <div className={style.layout}>
      <Head />
      <div className={style['layout-container']}>
        <Outlet />
      </div>
      {
        /^\/dealer\//.test(location.pathname) ? <DealerFooter /> : <DealerFooter />
      }
    </div>
  )
}

export default BaseLayout
